import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { fetchVaultData, resetFetchVaultData } from './actions/vault-actions';
import { bindActionCreators } from 'redux'
import VaultReceivedRoomsPage from './VaultReceivedRoomsPage'


const VaultReceivedRoomsPageContainer = (props) => {
  return (
    <VaultReceivedRoomsPage {...props} />
  )
}

const mapStateToProps = (state) => ({
  allUserDsrs: state.allUserDsrs.results.data,
  vaultIsProcessing: state.allUserDsrs.isLoading
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchVaultData, // TODO: Update to fetch only receied rooms data
      resetFetchVaultData
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VaultReceivedRoomsPageContainer))
